Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-cart-summary'),
        wrapper;

    var model = null;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    wrapper.loading = function loading (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function update () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("cartSummary_A", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function bind (html) {
        $wrapper.html(html);
    };

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data.Cart;
        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, wrapper, function (envelope) {
        wrapper.loading(false);
    }); 
});